module.exports = __webpack_public_path__ + "img/buy_super_ko.d4a5390d.png";